import React from "react";

const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_tiger-nurse-triage/artifacts/xs46u7q6_Logo%20aTriage.png";

export default function TigerLogo({ size = 32, className = "", alt = "@Tiger Professional" }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      width={size}
      height={size}
      className={`inline-block rounded-lg object-contain ${className}`}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}
